export const PageLoader = () => {
  return (
    <div className='flex items-center justify-center h-screen'>
      <div>Loading...</div>
    </div>
  );
};
